import authRoles from '../../../auth/authRoles';
import Security from './Security';

const SecurityConfig = {
  settings: {
    layout: {
      style: 'layoutMarketingV2',
      config: {
        header: {
          display: true
        },
        footer: {
          display: true
        }
      },
    },
  },
  auth: authRoles.onlyGuest,
  routes: [
    {
      path: '/security',
      element: <Security />,
    },
  ],
};

export default SecurityConfig;